/* eslint-disable max-len */
import React from 'react';

export function Plus() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="27"
      viewBox="0 0 27 27"
      style={{
        transform: 'scale(0.9)',
      }}
    >
      <path
        id="Icon_awesome-plus-square"
        data-name="Icon awesome-plus-square"
        d="M24.107,2.25H2.893A2.894,2.894,0,0,0,0,5.143V26.357A2.894,2.894,0,0,0,2.893,29.25H24.107A2.894,2.894,0,0,0,27,26.357V5.143A2.894,2.894,0,0,0,24.107,2.25ZM22.179,17.438a.725.725,0,0,1-.723.723H15.911v5.545a.725.725,0,0,1-.723.723H11.813a.725.725,0,0,1-.723-.723V18.161H5.545a.725.725,0,0,1-.723-.723V14.063a.725.725,0,0,1,.723-.723h5.545V7.795a.725.725,0,0,1,.723-.723h3.375a.725.725,0,0,1,.723.723v5.545h5.545a.725.725,0,0,1,.723.723Z"
        transform="translate(0 -2.25)"
        fill="#fff"
      />
    </svg>
  );
}

export function Tick() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="27"
      viewBox="0 0 27 27"
      style={{
        transform: 'scale(0.9)',
      }}
    >
      <path
        id="Exclusion_2"
        data-name="Exclusion 2"
        d="M5168,663h-21a3,3,0,0,1-3-3V639a3,3,0,0,1,3-3h21a3,3,0,0,1,3,3v21A3,3,0,0,1,5168,663Zm-18.384-14.836a.382.382,0,0,0-.27.115l-1.711,1.71a.386.386,0,0,0,0,.549l5.384,5.383a1.693,1.693,0,0,0,1.124.548,1.763,1.763,0,0,0,1.116-.528h.009l12.853-12.92a.411.411,0,0,0-.009-.548l-1.692-1.74a.357.357,0,0,0-.269-.115.347.347,0,0,0-.27.115l-11.728,11.815-4.269-4.268A.384.384,0,0,0,5149.616,648.164Z"
        transform="translate(-5144 -636)"
        fill="#fff"
      />
    </svg>
  );
}
